export default {
  clear: {
    id: 'searchbar_clear',
    defaultMessage: 'clear',
  },
}
